module.exports = __webpack_public_path__ + "static/images/lawson.s3W5zM5.svg";